// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ql-container.ql-snow,.ql-toolbar.ql-snow{border-color:#e2e5ec!important}", "",{"version":3,"sources":["webpack://./resources/assets/js/partials/Feeds/PodcastSettings/General.vue"],"names":[],"mappings":"AAAA,0CAAA,8BAAA","sourcesContent":[".ql-toolbar.ql-snow,.ql-container.ql-snow{border-color:#e2e5ec !important}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
